/** Tags inventory root. */
export const TAGS_ROOT = '/tags'

/** Query param that opens a graph tag in the inventory detail panel. */
export const TAGS_TAG_QUERY_PARAM = 'tag'

/** `/tags?tag=<tagId>` — Tags inventory with one graph tag selected. */
export function tagsTagHref(tagId: string): string {
  const params = new URLSearchParams()
  params.set(TAGS_TAG_QUERY_PARAM, tagId)
  return `${TAGS_ROOT}?${params.toString()}`
}
